// extracted by mini-css-extract-plugin
export default {"chartLegend":"ChartHtmlLegend_chartLegend__pQSAz","item":"ChartHtmlLegend_item__O-0Ij","label":"ChartHtmlLegend_label__D5PbQ","marker":"ChartHtmlLegend_marker__nGQki"};